import { render, staticRenderFns } from "./ReservationToDos.vue?vue&type=template&id=0366b265"
import script from "./ReservationToDos.vue?vue&type=script&lang=js"
export * from "./ReservationToDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports